const {
  NavLink
} = window.ReactRouterDOM;

class NavListItem extends React.Component{
	constructor(props) {
    super(props);
  }
	render(){
		return (
			<li className="nav__list__item">
				<NavLink to={this.props.link} className="nav__link" activeClassName="active" title={this.props.name}>
					<i className={this.props.iconClass} aria-hidden="true"></i>
				</NavLink>
			</li>
		);
	}
}
export { NavListItem };



// WEBPACK FOOTER //
// in/js/custom-components/nav/menu-item-component.js